import { GcpConfig } from '@/utils/gcs';
import adminHttp from '../adminHttp';
import { HttpResponse } from '../data.d';
import http from '../http';
import type { CheckCodeFormType, SendCodeFormType } from './data.d';

/** 获取是否登录 */
export function getIsLogin() {
  return http.post('/account/get-auth-status');
}

/** 获取当前登录用户信息 */
export function getUserInfo() {
  return http.post('/account/get-user-auth');
}

/** 获取时区列表 */
export function getTimezoneList() {
  return http.post('/common/get-timezone-list');
}

/** 获取国家、时区、语言 */
export function getCTLConfig() {
  return http.post(
    '/task/get-country-language',
    {},
    {
      params: { switchReqToUnderline: true },
    },
  );
}

/** 获取需要设置的配置 */
export function getConfigToBeSet() {
  return http.post('/settings/game-set-list');
}

/** 表单 - 获取需要设置的配置 */
export function getSignupFormConfig() {
  return http.post(
    '/signup_form/has_form',
    {},
    {
      params: { switchReqToUnderline: true },
    },
  );
}

/** 获取gcs配置 */
export function getGcsConfig(data: GcpConfig): Promise<HttpResponse> {
  return http.post('/cos/get-signed-url', data, {
    params: { switchReqToUnderline: true },
  });
}
/** 获取cos下载链接 */
export function getCosDownloadUrl(data: {
  fileName: string;
}): Promise<HttpResponse> {
  return http.post('/cos/get-download-url', data, {
    params: { switchReqToUnderline: true },
  });
}

/** 发送邮箱验证码 */
export function onSendEmailCode(data: SendCodeFormType) {
  return adminHttp.post('/common/sendCode', data);
}
/** 校验邮箱验证码 */
export function checkEmailCode(data: CheckCodeFormType) {
  return adminHttp.post('/common/checkCode', data);
}

// 获取用户操作日志
export function getUserOptLog(data: Record<any, any>) {
  return http.post(`/userOperation/list`, data, {
    params: { switchReqToUnderline: true },
  });
}

/** 记录用户行为 https://doc.weixin.qq.com/doc/w3_AbQAEQYZAGAmrCbMlspQAiSZgNHdU?scode=AJEAIQdfAAo3BShNeWAIsAlwZeAFI */
export function recordUserBehavior(data: {
  /** 模块id */
  moduleId: number;
  /** 行为id */
  behaviourId: number;
}) {
  return http.post('/audit/save-trail', data);
}

// 获取当前项目下首个用户加入的时间
export function getGameFirstUser(data: Record<any, any>) {
  return http.post(`/business_user/get_game_first_user`, data, {
    params: { switchReqToUnderline: true },
  });
}
